import { Button } from '@material-ui/core';
import SettingsIcon from '@material-ui/icons/Settings';
import { useEntity } from '@backstage/plugin-catalog-react';
import { useRouteRef } from '@backstage/core-plugin-api';
import { catalogPlugin } from '@backstage/plugin-catalog';
import { Link } from 'react-router-dom';

export function EditApplicationButton() {
  const { entity } = useEntity();
  const createFromTemplate = useRouteRef(
    catalogPlugin.externalRoutes.createFromTemplate,
  );

  const projectSlug = entity.metadata.annotations?.['github.com/project-slug'];

  if (!createFromTemplate || !projectSlug) {
    return null;
  }

  const githubRepository = projectSlug.replace(/^Mercell\//, '');
  const applicationName = entity.metadata.name;

  const templatePath = createFromTemplate({
    namespace: 'default',
    templateName: 'edit-application',
  });

  const formData = JSON.stringify({ githubRepository, applicationName });
  const href = `${templatePath}?formData=${encodeURIComponent(formData)}`;

  return (
    <Button
      variant="outlined"
      color="primary"
      startIcon={<SettingsIcon />}
      component={Link}
      to={href}
    >
      Edit Configuration
    </Button>
  );
}
